export default "__VITE_ASSET__uYnd1XoF__"